import { FieldContext } from 'lib/formContext'
import { type ReactNode, use } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  children?: ReactNode
  className?: string
}

export function HelperText({ children, className }: Props) {
  const context = use(FieldContext)

  return (
    <div
      id={context ? `${context?.id}-helper` : undefined}
      className={twMerge(
        'text-text-helper mt-1 label-01 whitespace-pre-wrap',
        context?.warning && 'text-text-primary',
        context?.error && 'text-support-error',
        context?.disabled && 'text-gray-disabled',
        className,
      )}
    >
      {children}
    </div>
  )
}
